/**
 * 商品列表接口
 */
export default {
    BASE_URL: '',
    api: [
        {
            name: 'detail',
            desc: '获取商品详情',
            method: 'GET',
            path: '/mm/sheftShop/productManage/ProductDetail'
        },
        {
            name: 'list',
            desc: '获取自营商品列表',
            method: 'POST',
            path: '/mm/sheftShop/productManage/productList'
        },
        {
            name: 'delete',
            desc: '删除商品',
            method: 'POST',
            path: '/mm/sheftShop/productManage/delProduct'
        },
        {
            name: 'deleteSpu',
            desc: '删除商品spu',
            method: 'POST',
            path: '/mm/sheftShop/productManage/spu/deleted'
        },
        {
            name: 'editPrice',
            desc: '编辑价格',
            method: 'POST',
            path: '/mm/sheftShop/productManage/adjustSKUPrice'
        },
        {
            name: 'getShelvesStatus',
            method: 'GET',
            desc: '获取商品列表状态',
            path: '/mm/sheftShop/productManage/getShelvesStatus'
        },
        {
            name: 'pullOff',
            desc: '下架',
            method: 'POST',
            path: '/mm/sheftShop/productManage/batchUnselftProds'
        },
        {
            name: 'toggleStatus',
            desc: '上下架',
            method: 'POST',
            path: '/mm/sheftShop/productManage/isShelfProduct'
        },
        {
            name: 'save',
            desc: '保存商品',
            method: 'POST',
            path: '/mm/sheftShop/productManage/openOrEditProduct'
        },
        {
            name: 'submit',
            desc: '提交商品（贤的上架商品。。。。）',
            method: 'POST',
            path: '/mm/sheftShop/productManage/putawayProduct'
        },
        {
            name: 'editProductSKUList',
            method: 'GET',
            desc: '调整商品价格列表',
            path: '/mm/sheftShop/productManage/editProductSKUList'
        },
        {
            name: 'isEnalbeProduct',
            method: 'POST',
            desc: '是否启用商品',
            path: '/mm/sheftShop/productManage/isEnalbeProduct '
        },
        {
            name: 'modifyPricelist',
            method: 'GET',
            desc: '批量修改价格-获取数据',
            path: '/mm/sheftShop/productManage/quickEdit'
        },
        {
            name: 'savePriceList',
            method: 'POST',
            desc: '批量修改价格-获取数据',
            path: '/mm/sheftShop/productManage/quickEdit'
        },
        {
            name: 'quickEditSpuList',
            method: 'GET',
            desc: '快速编辑-spu列表',
            path: '/mm/sheftShop/productManage/edit/spu'
        },
        {
            name: 'quickEditSkuList',
            method: 'GET',
            desc: '快速编辑-sku列表',
            path: '/mm/sheftShop/productManage/edit/sku'
        },
        {
            name: 'quickEditSkuSave',
            method: 'POST',
            desc: '快速编辑-sku保存',
            path: '/mm/sheftShop/productManage/edit/sku/save'
        },
        {
            name: 'skuPullOff',
            method: 'POST',
            desc: '批量下架sku',
            path: '/mm/sheftShop/productManage/spu/unShelves'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/pm/list.js